// utils/cleanfilenameCleaner.js

export function cleanFileName(name) {
  if (!name) return "";

  let cleaned = name;

  // 1️⃣ Replace ? used for apostrophes (e.g., Moody?s → Moody's)
  cleaned = cleaned.replace(/([A-Za-z])\?([A-Za-z]|s\b)/g, "$1'$2");

  // 2️⃣ Replace backticks and curly quotes with normal apostrophe
  cleaned = cleaned.replace(/[`‘’]/g, "'");

  // 3️⃣ Remove double quotes (open or close)
  cleaned = cleaned.replace(/["“”]/g, "");

  // 4️⃣ Replace em/en dashes or ? used as dash with hyphen (-)
  cleaned = cleaned.replace(/[—–]/g, "-");
  cleaned = cleaned.replace(/\s?\?\s?/g, " - ");

  // 5️⃣ Collapse extra spaces
  cleaned = cleaned.replace(/\s{2,}/g, " ").trim();

  return cleaned;
}
